import React, { FC, useMemo } from 'react';
import { ItemSelectionDropdown } from '@src/components/ItemSelectionDropdown';
import SectionTitle from '@src/components/SectionTitle';
import { BenefitsProps } from './props';

export const Benefits: FC<BenefitsProps> = ({ data, onChange, defaultValue }) => {
  const benefits = useMemo(() => {
    return (
      data?.map(item => ({
        label: item.value,
        value: item.id,
      })) || []
    );
  }, [data]);

  const defaultBenefits = useMemo(() => {
    return (
      defaultValue?.map(item => ({
        label: item.value,
        value: item.id,
      })) || []
    );
  }, [defaultValue]);

  return (
    <div className="benefits">
      <SectionTitle size="S" title="Perks and benefits" />

      <ItemSelectionDropdown
        defaultValue={defaultBenefits}
        onSelect={onChange}
        options={benefits}
        placeholder="Please select"
      />
    </div>
  );
};
